import(/* webpackMode: "eager", webpackExports: ["WebDevHero"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/app/[locale]/web-development/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Contact"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/agency/contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaBand"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/agency/cta-band.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingButtons"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/layout/floating-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/layout/nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/ui/BorderGlow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Marquee"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/components/ui/marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/k1dalica/Desktop/Projects/infiteq.io/node_modules/next/dist/client/script.js");
